'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useContext } from 'react';
import { DateTime } from 'luxon';
import { isPresent } from '@farmai-shared/LFUtils';
import { useLFSearchParams } from '@services/useLFSearchParams';
import { RootStoreContext } from '@stores/rootStore';
const getYearOption = (lang: string, year = DateTime.now().year.toString()) => ({
  label: lang === 'th' ? (parseInt(year, 10) + 543).toString() : year,
  value: parseInt(year, 10).toString()
});

// strict numeric parser: only accepts integers (e.g., "2025"), else null
const parseYearStrict = (value: string | null): number | null => {
  const v = value?.trim();
  return isPresent(v) && /^\d+$/.test(v) ? parseInt(v, 10) : null;
};
export const useActiveYear = () => {
  const $ = _c(20);
  const {
    userStore
  } = useContext(RootStoreContext);
  const {
    searchParams,
    setParams
  } = useLFSearchParams();
  const lang = userStore.user.settings.lang;
  let activeYear;
  let activeYearDisplay;
  let activeYearNumber;
  let defaultYear;
  let defaultYearNumber;
  let t0;
  let yearParam;
  if ($[0] !== lang || $[1] !== searchParams) {
    yearParam = searchParams.get("filter[year]");
    defaultYear = getYearOption(lang).value;
    activeYear = yearParam ?? defaultYear;
    activeYearNumber = parseYearStrict(activeYear);
    activeYearDisplay = isPresent(activeYearNumber) ? (lang === "th" ? activeYearNumber + 543 : activeYearNumber).toString() : "";
    defaultYearNumber = parseYearStrict(defaultYear);
    t0 = (lang === "th" ? defaultYearNumber + 543 : defaultYearNumber).toString();
    $[0] = lang;
    $[1] = searchParams;
    $[2] = activeYear;
    $[3] = activeYearDisplay;
    $[4] = activeYearNumber;
    $[5] = defaultYear;
    $[6] = defaultYearNumber;
    $[7] = t0;
    $[8] = yearParam;
  } else {
    activeYear = $[2];
    activeYearDisplay = $[3];
    activeYearNumber = $[4];
    defaultYear = $[5];
    defaultYearNumber = $[6];
    t0 = $[7];
    yearParam = $[8];
  }
  const defaultYearDisplay = t0;
  let t1;
  if ($[9] !== setParams) {
    t1 = next => {
      setParams([{
        key: "filter[year]",
        value: next
      }]);
    };
    $[9] = setParams;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  const setYear = t1;
  let t2;
  if ($[11] !== activeYear || $[12] !== activeYearDisplay || $[13] !== activeYearNumber || $[14] !== defaultYear || $[15] !== defaultYearDisplay || $[16] !== defaultYearNumber || $[17] !== setYear || $[18] !== yearParam) {
    t2 = {
      yearParam,
      defaultYear,
      activeYear,
      activeYearNumber,
      activeYearDisplay,
      defaultYearNumber,
      defaultYearDisplay,
      setYear
    };
    $[11] = activeYear;
    $[12] = activeYearDisplay;
    $[13] = activeYearNumber;
    $[14] = defaultYear;
    $[15] = defaultYearDisplay;
    $[16] = defaultYearNumber;
    $[17] = setYear;
    $[18] = yearParam;
    $[19] = t2;
  } else {
    t2 = $[19];
  }
  return t2;
};